import { forwardRef } from 'react';

import LdsButton from '../LdsButton/index.jsx';
import { getPlaceholder } from './datepicker.helpers.js';

export default forwardRef(function DateInput({
  label,
  id,
  dateFormat,
  dateValue,
  setDateValue,
  onChange,
  hint,
  isCalendarOpen,
  setIsCalendarOpen,
  disableCalendar,
  translation,
}, ref) {
  const placeholder = getPlaceholder(dateFormat);

  const handleInputTextChange = (e) => {
    let newValue = e.target.value;
    const separator = dateFormat === 'YYYY-MM-DD' ? '-' : '/';

    // Automatically add a slash if we are at the corresponding part of the string and they add another number
    const dateParts = dateFormat.split(separator);
    const shouldAddFirstSlash = newValue.length === dateParts[0].length + 1;
    const shouldAddSecondSlash = newValue.length === dateParts[0].length + dateParts[1].length + 2;
    const lastCharacter = newValue.slice(-1);
    const isLastSlash = lastCharacter === separator;
    if (
      (shouldAddFirstSlash || shouldAddSecondSlash)
      && !isLastSlash
    ) {
      newValue = dateValue + separator + lastCharacter;
    }

    setDateValue(newValue);
    onChange(newValue);
  };

  const handleInputTextKeyDown = (e) => {
    // Only allow separator to be typed into the input when appropriate
    const separator = dateFormat === 'YYYY-MM-DD' ? '-' : '/';
    if ((separator === '-' && e.key === '/')
      || (separator === '/' && e.key === '-')
    ) {
      e.preventDefault();
    }

    const dateParts = dateFormat.split(separator);
    const isFirstSlash = dateValue.length === dateParts[0].length;
    const isSecondSlash = dateValue.length === dateParts[0].length + dateParts[1].length + 1;
    if (e.key === separator && !isFirstSlash && !isSecondSlash) {
      e.preventDefault();
    }
  };

  return (
    <div>
      <label
        htmlFor={id}
        className="lds-form-label">
        {label}
        <span
          className="lds-form-hint"
        >
          {hint}
        </span>
      </label>
      <div className="lds-datepicker-input-wrapper">
        <input
          id={id}
          className="lds-text-field lds-datepicker-input"
          type="text"
          inputMode="numeric"
          placeholder={placeholder}
          value={dateValue}
          maxLength={10}
          onKeyDown={handleInputTextKeyDown}
          onChange={handleInputTextChange}
          ref={ref}
        />
        {
          !disableCalendar
          && <LdsButton
            onClick={() => setIsCalendarOpen(!isCalendarOpen)}
            icon="CalendarBlank"
            aria-label={translation.calendarBtnAria}
            iconOnly
          ></LdsButton>
        }
      </div>
    </div>
  );
});
